module.exports = __webpack_public_path__ + "static/media/briefIntroduction.6434eb66.png";